import React, {
  useEffect,
  useState
} from "react";
import {
  shallowEqual,
  useSelector
} from "react-redux";
import {
  getWorkHistoryCommuteAllList
} from "../../apis/work-history";
import {
  CardHeader,
  ColCard,
  CardTitle
} from "../../components/ContentLayout";
import CustomList from "../../components/List";
import {
  getDay
} from "../../utils/date";
import {
  isEmpty
} from "../../utils/lodashExtend";
import {
  getAllAbsenteeList
} from "../../utils/work-schedule-calculator";

const AttendanceStatusBoard = () => {

  // employees
  const {
    employees,
    myRoleEmployeesIdx,
    permissions
  } = useSelector(
    (store) => ({
      employees: store.Data.employees,
      myRoleEmployeesIdx: store.Data.myRoleEmployeesIdx,
      permissions: store.Profile.permissions
    }),
    shallowEqual
  );
  const [list, setList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      setTargetPermission(permissions.find(p => p.code === 'WORK_HISTORY'))
    }
  }, [permissions])

  const fields = [{
    type: 'profile',
    key: 'user',
    width: '60%'
  },
  {
    key: 'data',
    width: '40%'
  }
  ]

  const submit = () => {
    setIsLoading(true)
    setList([])
    getWorkHistoryCommuteAllList({
      search: {
        employeeIdxs: myRoleEmployeesIdx
      },
      range: {
        startDate: getDay(),
        endDate: getDay(),
      },
    }).then((res) => {
      const commuteList = res.data.data
      const {
        notCommutedList,
        tardyList,
        earlyLeftList,
        vacationAllList,
        vacationHalfList,
        vacationQuarterList,
      } = getAllAbsenteeList(commuteList, employees)


      setList([
        ...notCommutedList.map(({
          name,
          title,
          ...e
        }) => ({
          user: {
            ...e,
            name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}`
          },
          //data: title || '미출근'
          data: '미출근'
        })),
        ...tardyList.map(({
          name,
          title,
          ...e
        }) => ({
          user: {
            ...e,
            name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}`
          },
          //data: title || '지각'
          data: '지각'
        })),
        ...earlyLeftList.map(({
          name,
          title,
          ...e
        }) => ({
          user: {
            ...e,
            name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}`
          },
          //data: title || '조퇴'
          data: '조퇴'
        })),
        ...vacationAllList.map(({
          name,
          title,
          ...e
        }) => ({
          user: {
            ...e,
            name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}`
          },
          data: '휴가'
        })),
        ...vacationHalfList.map(({
          name,
          title,
          ...e
        }) => ({
          user: {
            ...e,
            name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}`
          },
          //data: title || '반차'
          data: '반차'
        })),
        ...vacationQuarterList.map(({
          name,
          title,
          ...e
        }) => ({
          user: {
            ...e,
            name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}`
          },
          data: '반반차'
        })),
      ])
    }).finally(() => {
      setIsLoading(false)
    })

  }

  useEffect(() => {
    if (!isEmpty(myRoleEmployeesIdx) && targetPermission) submit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employees, myRoleEmployeesIdx, targetPermission])

  return <>
    <ColCard
      type="light"
      className="attendance-status-board" >
      <CardHeader>
        <CardTitle>
          오늘의 부재자
        </CardTitle> {
          /* <CardUnit>
                    팀
                  </CardUnit> */
        } </CardHeader>
      <div className="attendance-status-list">
        <CustomList
          height={
            265
          }
          list={
            list
          }
          isLoading={
            isLoading
          }
          fields={
            fields
          }
        /> </div>
    </ColCard>
  </>
}

export default AttendanceStatusBoard